export const messageTemplateVariableFormat = "<<{0}>>";
export const messageTemplateAngleFormat = "<<{0}>>";
export const messageTemplateCurlyFormat = "${{0}}";
